import colors from "./Colors";

export const tokens = {
  Primary: {
    Primary200: colors.Blue.Blue50,
    Primary400: colors.Blue.Blue400
  },
  Text: {
    General: {
      PrimaryHeadline: colors.Neutral.Neutral800,
      PrimaryBody: colors.Neutral.Neutral700,
      Secondary: colors.Neutral.Neutral600,
      Tertiary: colors.Neutral.Neutral500,
      Inverse: colors.Neutral.Neutral0,
      Color: colors.Blue.Blue500
    },
    Feedback: {
      Progress: colors.Cyan.Cyan600,
      ProgressDark: colors.Cyan.Cyan800,
      Done: colors.Green.Green600,
      Overdue: colors.Orange.Orange600,
      OverdueDark: colors.Orange.Orange800,
      Alert: colors.Red.Red500,
      Warning: colors.Yellow.Yellow700,
      Neutral: colors.Neutral.Neutral800,
      SuccessDark: colors.Green.Green800
    }
  },
  Draggable: {
    General: {
      Background: colors.Neutral.Neutral200,
      Border: colors.Neutral.Neutral300,
      Text: colors.Neutral.Neutral900,
      DraggedItem: colors.Blue.Blue100,
      DraggedText: colors.Blue.Blue500
    }
  },
  Background: {
    General: {
      Primary: colors.Neutral.Neutral0,
      Secondary: colors.Neutral.Neutral50,
      Tertiary: colors.Neutral.Neutral200,
      Color: colors.Blue.Blue50,
      LightColor: colors.Blue.Blue400
    },
    Feedback: {
      Alert: colors.Red.Red100,
      Warning: colors.Yellow.Yellow100,
      Success: colors.Green.Green50,
      Info: colors.Neutral.Neutral200
    }
  },
  Border: {
    General: {
      Primary: colors.Neutral.Neutral600,
      Secondary: colors.Neutral.Neutral400,
      Tertiary: colors.Neutral.Neutral200,
      Inverse: colors.Neutral.Neutral0,
      Color: colors.Blue.Blue500,
      LightColor: colors.Blue.Blue400
    },
    Feedback: {
      Alert: colors.Red.Red500,
      LightAlert: colors.Red.Red300,
      Success: colors.Green.Green400,
      Warning: colors.Yellow.Yellow400
    }
  },
  Icon: {
    General: {
      Primary: colors.Neutral.Neutral800,
      Secondary: colors.Neutral.Neutral600,
      Tertiary: colors.Neutral.Neutral500,
      Inverse: colors.Neutral.Neutral0,
      Color: colors.Blue.Blue500
    },
    Feeback: {
      Alert: colors.Red.Red500,
      Warning: colors.Yellow.Yellow700,
      Success: colors.Green.Green600,
      Progress: colors.Cyan.Cyan600,
      Overdue: colors.Orange.Orange600
    }
  },
  BoxShadow: `0px 0px 1px ${colors.Shadow.Shadow0}, 0px 2px 4px ${colors.Shadow.Shadow10}`,
  Graph: {
    PlansCompleted: colors.Purple.Purple500,
    CardsCompleted: colors.Blue.Blue500
  }
};
